import React from 'react';
import { Section } from './ui/Section';
import { Anchor, Clock, Leaf, Utensils } from 'lucide-react';
export function SolutionSection() {
  return <Section background="cream" id="method" data-id="element-165">
      <div className="text-center mb-12" data-id="element-166">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm-dark mb-4" data-id="element-167">
          Presento: Método 3 Anclas
        </h2>
        <p className="text-xl text-warm-gray max-w-2xl mx-auto" data-id="element-168">
          Un sistema simple para cerrar el "portal" de antojos donde se te va el
          día.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mt-12" data-id="element-169">
        <Card icon={<Utensils className="w-8 h-8 text-terracotta" data-id="element-171" />} title="Ancla #1: Proteína" description="Aseguramos el mínimo necesario para que tu comida realmente 'sostenga' y no tengas hambre a la hora." data-id="element-170" />
        <Card icon={<Leaf className="w-8 h-8 text-terracotta" data-id="element-173" />} title="Ancla #2: Fibra" description="Un objetivo simple de saciedad para aplanar los picos de glucosa que te causan sueño." data-id="element-172" />
        <Card icon={<Clock className="w-8 h-8 text-terracotta" data-id="element-175" />} title="Ancla #3: Timing" description="Reglas estratégicas para el café y la cena, para que la tarde y la noche no te secuestren." data-id="element-174" />
      </div>

      <div className="mt-12 text-center" data-id="element-176">
        <p className="text-lg text-warm-dark font-medium" data-id="element-177">
          No es "comer perfecto". Es diseñar tu día para que tu cuerpo no pida
          rescate a las 6pm.
        </p>
      </div>
    </Section>;
}
function Card({
  icon,
  title,
  description
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) {
  return <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-cream-dark" data-id="element-178">
      <div className="bg-cream w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-179">
        {icon}
      </div>
      <h3 className="text-xl font-bold text-warm-dark mb-3 text-center" data-id="element-180">
        {title}
      </h3>
      <p className="text-warm-gray text-center leading-relaxed" data-id="element-181">
        {description}
      </p>
    </div>;
}